import React from "react";
import "./style/Template.css";
import "./style/address.css";
import "./style/Categories.css";
import "./style/CostumerClub.css";
import "./style/Profile.css";
import "./style/Drawer.css";
import "./style/homePage.css";
import "./style/Installments.css";
import "./style/mainPage.css";
import "./style/multiVendor.css";
import "./style/myOrders.css";
import "./style/notifacation.css";
import "./style/OrderDetails.css";
import "./style/PopUps.css";
import "./style/Product.css";
import "./style/shoppingCart.css";
import "./style/showMore.css";
import "./style/Vendor.css";
import "./style/Emergency.css";
import "./style/Garages.css";
import "./style/Dashboard.css";
import "./public/public/assets/icomoon/style.css";
import "./iranyekan/css/fontiran.css";
import "semantic-ui-css/semantic.min.css";
import "swiper/css";
import { BrowserRouter as Router, Switch, Route } from "routerCompat";
import homePage from "./Component/homePage/homePage";
import mainPage from "./Component/mainPage/mainPage";
import SpecialItems from "./Component/SpecialItems/SpecialItems";
import PopularCarsItems from "./Component/PopularCars/PopularCarsItems";
import Categories from "./Component/Categories/Categories";
import carFiltering from "./Component/Categories/carFiltering";
import Search from "./Component/mainPage/Search";
import AddCars from "./Component/mainPage/AddCars";
import Products from "./Component/Products/Products";
import OtherVendors from "./Component/Products/OtherVendors";
import Installments from "./Component/Installments/Installments";
// import NewOne from "./Component/shoppingCart.js/newOne";
import shoppingCart from "./Component/shoppingCart.js/shoppingCart";
import rule from "./Component/Installments/rule";
import enterPhone from "./Component/Entrance/enterPhone";
import EnterPass from "./Component/Entrance/logIn/EnterPass";
import info from "./Component/Entrance/signUp/info";
import forgetPassStep1 from "./Component/Entrance/logIn/forgetPassStep1";
import forgetPassStep2 from "./Component/Entrance/logIn/forgetPassStep2";
import checkCode from "./Component/Entrance/signUp/checkCode";
import AboutUs from "./Component/AboutUs/AboutUs";
import NewAddresses from "./Component/shoppingCart.js/NewAddresses";
import CitySelection from "./Component/homePage/citySelection";
import showMore from "./Component/showMore/showMore";
import profile from "./Component/profile/profile";
import myOrders from "./Component/myOrders/myOrder";
import Ticket from "./Component/OrderDetails/ticket";
import OrderDetails from "./Component/OrderDetails/OrderDetails";
import ChangeCity from "./Component/profile/ChangeCity";
import MainMap from "./Component/OrderDetails/map";
import MovingService from "../src/Component/shoppingCart.js/movingService";
import FixedService from "../src/Component/shoppingCart.js/fixedService";
// import Rules from "./Component/Rules/rules";
import ChangePass from "./Component/profile/ChangePass";
import Delivery from "./Component/shoppingCart.js/delivery";
import selectedCity from "./Component/homePage/selectedCity";
import PaymentFailed from "./Component/shoppingCart.js/paymentFailed";
import PaymentSuccessful from "./Component/shoppingCart.js/paymentSuccessful";
import PaymentResult from "./Component/shoppingCart.js/paymentResult";
import RulesAndConditions from "./Component/Entrance/rulesAndConditions";
import carSelectionRemainder from "./Component/reminder/carSelectionRemainder";
import AddReminder from "./Component/reminder/AddReminder";
import AddUserCar from "./Component/reminder/AddUserCar";
import notifacation from "./Component/notifacation/notifacation";
import multiVendor from "./Component/multiVendor/multiVendor";
import categoryDetails from "./Component/multiVendor/categoryDetails";
import Reservation from "./Component/multiVendor/Reservation";
import Certificates from "./Component/multiVendor/Certificates";
import myRequest from "./Component/multiVendor/myRequest";
import Filter from "./Component/multiVendor/Filter";
import CertificateImg from "./Component/multiVendor/CertificateImg";
import guildServicePrices from "./Component/multiVendor/guildServicePrices";
import myRequestOrdersDetails from "./Component/multiVendor/myRequestOrdersDetails";
import myRequestOrdersDetailsMap from "./Component/multiVendor/myRequestOrdersDetailsMap";
import kacharSupport from "./Component/showMore/kacharSupport";
import Refferal from "./Component/showMore/Refferal";
import TicketDetails from "./Component/showMore/TicketDetails";
import ReplyTicket from "./Component/showMore/ReplyTicket";
import ContactSupport from "./Component/showMore/ContactSupport";
import ClubKachar from "./Component/CostumerClub//ClubKachar/ClubKachar";
import Bazarche from "./Component/CostumerClub/Bazarche/Bazarche";
import { LottaryPage } from "./Component/CostumerClub/LottaryPage/LottaryPage";
import ReturnTerms from "./Component/Products/ReturnTerms";
import { Scores } from "./Component/CostumerClub/Scores/Scores";
import { HistoryPage } from "./Component/CostumerClub/HistoryPage/HistoryPage";
import MyFavorite from "./Component/profile/MyFavorite";
import CommentDashboard from "./Component/profile/CommentDashboard";
import RecentVisit from "./Component/profile/RecentVisit";
import InviteFriend from "./Component/profile/InviteFriend";
import { isLogin } from "./utils/utils.js";
// import Service from "./Component/shoppingCart.js/Service";
import MyCars from "./Component/profile/MyCars";
import ChooseAddress from "./Component/profile/ChoseAddress";
import AddCar from "./Component/profile/AddCar";
import AddCommentDashboard from "./Component/PopUps/AddComment";
import Changename from "./Component/Drawer/Changeename";
import PopularCars from "./Component/PopularCars/PopularCars";
import Checkout from "./Component/shoppingCart.js/checkout/checkout";
import UserInfo from "./Component/Entrance/signUp/UserInfo";
import InstallmentsProducts from "./Component/Installments/InstallmentsProducts";
import Rules from "./Component/showMore/Rules";
import MajorRules from "./Component/major/MajorRules";
import BrandsProducts from "./Component/brand/BrandsProducts";
import FAQ from "./Component/CostumerClub/FAQ";
import Unauthorized from "./Component/global/401";
import Unavailable from "./Component/global/404";
import Vendor from "./Component/vendor/Vendor";
import Emergency from "./Component/emergency/Emergency";
import NewService from "./Component/emergency/newService/NewService";
import ServiceHistories from "./Component/emergency/history/ServiceHistories";
import HistoryItemDetail from "./Component/emergency/history/HistoryItemDetail";
import Services from "./Component/Services/Services";
import ServiceItemDetails from "./Component/Services/serviceItem/ServiceItemDetails";
import Reserve from "./Component/Services/serviceItem/Reserve";
import ServiceHistory from "./Component/Services/history/ServiceHistory";
import { HistroyDetail } from "./Component/Services/HistoryDetail/HistroyDetail";
import Wallet from "./Component/profile/Wallet";
import Brands from "./Component/brands/Brands";
import CancelOrder from "./Component/OrderDetails/CancelOrder";
import ReportProblem from "./Component/myOrders/submitProblem.js";
import Evaluation from "./Component/profile/Evaluation.js";
import EvaluationDetail from "./Component/profile/EvaluationDetail.js";
import LegalInfo from "./Component/profile/LegalInfo.js";
import Tags from "./Component/tags/Tags.js";
class Routes extends React.Component {
  render() {
    const isAuthenticated = isLogin();
    return (
      <Router>
        <Switch>
          <Route
            exact
            path={`${localStorage.getItem("Api_key") ? "/EnterPhone" : "/"}`}
            component={enterPhone}
          ></Route>
          <Route
            exact
            path="/rulesAndConditions"
            component={RulesAndConditions}
          ></Route>
          <Route exact path="/checkCode" component={checkCode}></Route>
          <Route exact path="/info" component={UserInfo}></Route>
          <Route exact path="/EnterPass" component={EnterPass}></Route>
          <Route
            exact
            path="/EnterPass/forgetPassStep1"
            component={forgetPassStep1}
          ></Route>
          <Route
            exact
            path="/EnterPass/forgetPassStep2"
            component={forgetPassStep2}
          ></Route>
          <Route exact path="/profile/changeLocation" component={info}></Route>
          <Route
            exact
            path={`${localStorage.getItem("Api_key") ? "/" : "/homePage"}`}
            component={homePage}
          ></Route>
          <Route exact path="/mainPage" component={mainPage}></Route>
          <Route exact path="/section/:slug" component={SpecialItems}></Route>
          {/* <Route exact path='/SpecialItems' component={SpecialItems}></Route> */}
          <Route
            exact
            path="/categories/:categoryId"
            component={Categories}
          ></Route>
          <Route exact path="/tags/:tag_id" component={Tags}></Route>
          <Route
            exact
            path="/PopularCarsItems"
            component={PopularCarsItems}
          ></Route>
          <Route
            exact
            path="/categories/:categoryId/:subCategoryId"
            component={Categories}
          ></Route>
          <Route
            exact
            path="/popular_cars/:carId/:carBrandId/:categoryId"
            component={PopularCars}
          ></Route>
          <Route
            exact
            path="/popular_cars/:carId/:carBrandId/:categoryId/:subCategoryId"
            component={PopularCars}
          ></Route>
          <Route
            exact
            path="/brand/:id/:categoryId?"
            component={BrandsProducts}
          ></Route>
          <Route exact path="/carFiltering" component={carFiltering}></Route>
          <Route exact path="/search" component={Search}></Route>
          <Route exact path="/search/:addCars" component={AddCars}></Route>
          <Route exact path="/Product/:id/:organ?" component={Products}></Route>
          <Route exact path="/vendors" component={OtherVendors}></Route>
          <Route exact path="/Installments" component={Installments}></Route>
          <Route exact path="/Installments/rules" component={rule}></Route>
          {/* <Route exact path="/multiBasket" component={NewOne}></Route> */}
          <Route exact path="/shoppingCart" component={shoppingCart}></Route>
          <Route
            exact
            path="/shoppingCart/checkout"
            component={Checkout}
          ></Route>
          <Route exact path="/aboutUs" component={AboutUs}></Route>
          <Route exact path="/showMore" component={showMore}></Route>
          <Route exact path="/citySelection" component={CitySelection}></Route>
          <Route
            exact
            path="/citySelection/City"
            component={selectedCity}
          ></Route>
          <Route
            exact
            path="/profile"
            component={isAuthenticated ? profile : enterPhone}
          ></Route>
          <Route
            exact
            path="/profile/ChangePass"
            component={ChangePass}
          ></Route>
          <Route exact path="/profile/myOrders" component={myOrders}></Route>
          <Route exact path="/changeCity" component={ChangeCity}></Route>
          <Route
            exact
            path="/orderDetails/:id"
            component={OrderDetails}
          ></Route>
          <Route
            exact
            path="/orderDetails/:id/cancelOrder"
            component={CancelOrder}
          ></Route>
          <Route
            exact
            path="/orderDetails/:id/submitProblem/:item_vendor_id/:vendor_id"
            component={ReportProblem}
          ></Route>

          <Route exact path="/ticket" component={Ticket}></Route>
          <Route exact path="/mainMap" component={MainMap}></Route>
          <Route exact path="/fixedService" component={FixedService}></Route>
          <Route exact path="/movingService" component={MovingService}></Route>
          <Route exact path="/rules" component={Rules}></Route>
          {/* <Route exact path="/Service" component={Service}></Route> */}
          <Route path="/profile/ChangePass" component={ChangePass}></Route>
          <Route exact path="/profile/myOrders" component={myOrders}></Route>
          <Route exact path="/changeCity" component={ChangeCity}></Route>
          <Route exact path="/showMore/Refferal" component={Refferal}></Route>
          <Route
            exact
            path="/shoppingCart/delivery"
            component={Delivery}
          ></Route>
          <Route exact path="/paymentFailed" component={PaymentFailed}></Route>
          <Route
            exact
            path="/paymentSuccessful"
            component={PaymentSuccessful}
          ></Route>
          <Route exact path="/paymentResult" component={PaymentResult}></Route>
          <Route
            exact
            path="/carSelection"
            component={carSelectionRemainder}
          ></Route>
          <Route
            exact
            path="/carSelection/addUserCar"
            component={AddUserCar}
          ></Route>
          <Route exact path="/addReminder" component={AddReminder}></Route>
          <Route exact path="/notifacation" component={notifacation}></Route>
          <Route exact path="/multiVendor" component={multiVendor}></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails"
            component={categoryDetails}
          ></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails/guildServicePrices"
            component={guildServicePrices}
          ></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails/Reservation"
            component={Reservation}
          ></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails/Certificates"
            component={Certificates}
          ></Route>
          <Route
            exact
            path="/multiVendor/myRequest"
            component={myRequest}
          ></Route>
          <Route
            exact
            path="/multiVendor/myRequest/OrderDetails"
            component={myRequestOrdersDetails}
          ></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails/location"
            component={myRequestOrdersDetailsMap}
          ></Route>
          <Route exact path="/multiVendor/Filter" component={Filter}></Route>
          <Route
            exact
            path="/multiVendor/categoryDetails/Certificates/CertificateImg"
            component={CertificateImg}
          ></Route>
          <Route
            exact
            path="/showMore/Support"
            component={kacharSupport}
          ></Route>
          <Route
            exact
            path="/showMore/Support/TicketDetails"
            component={TicketDetails}
          ></Route>
          <Route
            exact
            path="/showMore/Support/ReplyTicket"
            component={ReplyTicket}
          ></Route>
          <Route
            exact
            path="/installments/products"
            component={InstallmentsProducts}
          ></Route>
          <Route exact path="/showMore/rules" component={Rules}></Route>
          <Route
            exact
            path="/profile/ContactSupport"
            component={ContactSupport}
          ></Route>
          {/* club */}
          <Route exact path="/bazarche" component={Bazarche}></Route>
          <Route exact path="/customerclub" component={ClubKachar}></Route>
          <Route
            exact
            path="/customerclub/bazarche"
            component={Bazarche}
          ></Route>
          <Route
            exact
            path="/customerclub/lottarypage/:id"
            component={LottaryPage}
          />
          <Route exact path="/customerclub/scores" component={Scores}></Route>
          <Route path={"/customerclub/history"} component={HistoryPage} />
          <Route path={"/customerclub/faq"} component={FAQ} />
          {/* end of club routes */}
          <Route exact path="/ReturnTerms" component={ReturnTerms}></Route>
          <Route
            exact
            path="/profile/MyFavorite"
            component={MyFavorite}
          ></Route>
          <Route
            exact
            path="/profile/CommentDashboard"
            component={CommentDashboard}
          ></Route>

          <Route
            exact
            path="/profile/RecentVisit"
            component={RecentVisit}
          ></Route>
          <Route
            exact
            path="/profile/InviteFriend"
            component={InviteFriend}
          ></Route>
          <Route
            exact
            path="/profile/chooseAddress"
            component={ChooseAddress}
          ></Route>
          <Route
            exact
            path="/profile/editAddress/:id"
            component={NewAddresses}
          ></Route>
          <Route exact path="/profile/Wallet" component={Wallet} />
          <Route
            exact
            path="/profile/addAddress"
            component={NewAddresses}
          ></Route>
          <Route exact path="/profile/MyCars" component={MyCars} />
          <Route exact path="/profile/addCar" component={AddCar} />
          <Route
            exact
            path="/addComment/:order_id/:item_id"
            component={AddCommentDashboard}
          />
          <Route exact path="/profile/changename" component={Changename} />
          <Route
            exact
            path="/vendor/:vendor_id/:categoryId"
            component={Vendor}
          />
          <Route exact path="/emergency" component={Emergency} />
          <Route exact path="/emergency/new-service" component={NewService} />
          <Route exact path="/emergency/history" component={ServiceHistories} />
          <Route
            exact
            path="/emergency/history/details"
            component={HistoryItemDetail}
          />
          <Route exact path="/services" component={Services} />
          <Route
            exact
            path="/services/serviceItemDetails"
            component={ServiceItemDetails}
          />
          <Route
            exact
            path="/services/serviceItemDetails/reserve"
            component={Reserve}
          />
          <Route exact path="/services/history" component={ServiceHistory} />
          <Route
            exact
            path="/services/history/detail/:orderId/:type"
            component={HistroyDetail}
          />
          <Route path="/legalInfo" component={LegalInfo} />

          <Route exact path="/major/rules" component={MajorRules} />
          <Route exact path="/brands/:brandId" component={Brands} />
          <Route exact path={"/404"} component={Unavailable} />
          <Route exact path={"/401"} component={Unauthorized} />
          <Route exact path={`/evaluation`} component={Evaluation} />
          <Route exact path={`/evaluation/:id`} component={EvaluationDetail} />
        </Switch>
      </Router>
    );
  }
}
export default Routes;
